// hooks/useUrlParams.js
import { useLocation, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const useUrlParams = (componentName) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [urlParams, setUrlParams] = useState({});

  useEffect(() => {
    const params = Object.fromEntries(searchParams.entries());
    //console.log(`🔗 [${componentName}] Parámetros URL detectados:`, params);
    setUrlParams(params);
  }, [location.search, componentName]);

  const getParam = (key, defaultValue = null) => {
    return urlParams[key] || defaultValue;
  };

  const setParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value === null || value === undefined) {
      newSearchParams.delete(key);
    } else {
      newSearchParams.set(key, value);
    }
    setSearchParams(newSearchParams);
  };

  const clearParam = (key) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(key);
    setSearchParams(newSearchParams);
  };

  return {
    urlParams,
    getParam,
    setParam,
    clearParam,
    hasParams: Object.keys(urlParams).length > 0
  };
};